<template>
  <div @mousedown="com_SetLastActivityTime">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    isRtl() {
      return this.$i18n.locale === "ar";
    }
  }
};
</script>
